var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutorenew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16.0 23.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "autorenew_i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "autorenew_i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.76,6.74 C15.54,7.97 16,9.43 16,11 C16,15.42 12.42,19 8,19 L8,22 L4,18 L8,14 L8,17 C11.31,17 14,14.31 14,11 C14,9.99 13.74,9.04 13.3,8.2 L14.76,6.74 Z M8,0 L12,4 L8,8 L8,5 C4.69,5 2,7.69 2,11 C2,12.01 2.25,12.97 2.7,13.8 L1.24,15.26 C0.46,14.03 0,12.57 0,11 C0,6.58 3.58,3 8,3 L8,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-132.0 -1091.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#autorenew_i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.99999999999858 1090.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.0 1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#autorenew_i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 16,0 16,22 0,22 0,0",
    stroke: "none"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutorenew);
export default __webpack_public_path__ + "static/media/autorenew.0d4482780b2cbb8a5dc666b56e5259f6.svg";
export { ForwardRef as ReactComponent };